module.exports = __webpack_public_path__ + "static/media/no_submitted.084c8c49.png";